/**
 @author xcf
 @date 2020/6/29 11:00 上午
 */
//背景
export const backList = [
    {img: `back/back1.png`},
    {img: `back/back2.png`},
    {img: `back/back3.png`},
    {img: `back/back4.png`},
    {img: `back/back5.png`},
    {img: `back/back6.png`},
    {img: `back/back7.png`},
    {img: `back/back8.png`},
    {img: `back/back9.png`},
    {img: `back/back10.png`},
    {img: `back/back11.png`},
    {img: `back/back12.png`},
    {img: `back/back13.png`},
    {img: `back/back14.png`},
    {img: `back/back15.png`},
    {img: `back/back16.png`},
    {img: `back/back17.png`},
    {img: `back/back18.png`},
    {img: `back/back19.png`},
];

//边框
export const borderList = [
    {img: `border/border1.png`},
    {img: `border/border2.png`},
    {img: `border/border3.png`},
    {img: `border/border4.png`},
    {img: `border/border5.png`},
    {img: `border/border6.png`},
    {img: `border/border7.png`},
    {img: `border/border8.png`},
    {img: `border/border9.png`},
    {img: `border/border10.png`},
    {img: `border/border11.png`},
    {img: `border/border12.png`},
    {img: `border/border13.png`},
    {img: `border/border14.png`},
    {img: `border/border15.png`},
    {img: `border/border16.png`},
    {img: `border/border17.png`},
    {img: `border/border18.png`},
    {img: `border/border19.png`},
    {img: `border/border20.png`},
    {img: `border/border21.png`},
    {img: `border/border22.png`},
    {img: `border/border23.png`},
    {img: `border/border24.png`},
    {img: `border/border25.png`},
    {img: `border/border26.png`},
    {img: `border/border27.png`},
    {img: `border/border28.png`},
    {img: `border/border29.png`},
    {img: `border/border30.png`},
    {img: `border/border31.png`},
    {img: `border/border32.png`},
    {img: `border/border33.png`},
    {img: `border/border34.png`},
    {img: `border/border35.png`},
    {img: `border/border36.png`},
    {img: `border/border37.png`},
    {img: `border/border38.png`},
    {img: `border/border39.png`},
    {img: `border/border40.png`},
    {img: `border/border41.png`},
    {img: `border/border42.png`},
    {img: `border/border43.png`},
    {img: `border/border44.png`},
    {img: `border/border45.png`},
    {img: `border/border46.png`},
    {img: `border/border47.png`},
    {img: `border/border48.png`},
    {img: `border/border49.png`},
    {img: `border/border50.png`},
    {img: `border/border51.png`},
];

// 图片
export const  pictureList = [
    {img: `picture/picture2.gif`},
    {img: `picture/picture3.png`},
    {img: `picture/picture4.png`},
    {img: `picture/picture5.png`},
    {img: `picture/picture6.png`},
    {img: `picture/picture7.png`},
    {img: `picture/picture8.png`},
    {img: `picture/picture9.png`},
    {img: `picture/picture10.png`},
    {img: `picture/picture11.gif`},
    {img: `picture/picture12.png`},
    {img: `picture/picture13.png`},
    {img: `picture/picture14.png`},
    {img: `picture/picture15.png`},
    {img: `picture/picture16.png`},
    {img: `picture/picture17.png`},
    {img: `picture/picture18.png`},
    {img: `picture/picture19.png`},
    {img: `picture/picture20.png`},
    {img: `picture/picture21.png`},
    {img: `picture/picture22.png`},
    {img: `picture/picture23.png`},
    {img: `picture/picture24.png`},
    {img: `picture/picture25.png`},
    {img: `picture/picture26.png`},
    {img: `picture/picture27.png`},
    {img: `picture/picture28.png`},
    {img: `picture/picture29.png`},
    {img: `picture/picture30.png`},
    {img: `picture/picture31.png`},
    {img: `picture/picture32.png`},
    {img: `picture/picture33.png`},
    {img: `picture/picture34.png`},
    {img: `picture/picture35.png`},
    {img: `picture/picture36.png`},
    {img: `picture/picture37.png`},
    {img: `picture/picture38.png`},
    {img: `picture/picture39.png`},
    {img: `picture/picture40.png`},
    {img: `picture/picture41.png`},
    {img: `picture/picture42.png`},
    {img: `picture/picture43.png`},
    {img: `picture/picture44.png`},
    {img: `picture/pic1.png`},
    {img: `picture/pic2.png`},
    {img: `picture/pic3.png`},
    {img: `picture/pic4.png`},
    {img: `picture/pic5.png`},
    {img: `picture/pic6.png`},
    {img: `picture/pic7.png`},
    {img: `picture/pic8.png`},
    {img: `picture/pic9.png`},
    {img: `picture/pic10.png`},
    {img: `picture/pic11.png`},
    {img: `picture/pic12.png`},
    {img: `picture/pic13.png`},
    {img: `picture/pic14.png`},
    {img: `picture/pic15.png`},
    {img: `picture/pic16.png`},
    {img: `picture/pic17.png`},
    {img: `picture/pic18.png`},
    {img: `picture/pic19.png`},
    {img: `picture/pic20.png`},
    {img: `picture/pic21.png`},
    {img: `picture/pic22.png`},
    {img: `picture/pic23.png`},
    {img: `picture/pic24.png`},
    {img: `picture/pic25.png`},
    {img: `picture/pic26.png`},
    {img: `picture/pic27.png`},
    {img: `picture/pic28.png`},
    {img: `picture/pic29.png`},
    {img: `picture/pic30.png`},
    {img: `picture/pic31.png`},
    {img: `picture/pic32.png`},
    {img: `picture/pic33.png`},
    {img: `picture/pic34.png`},
    {img: `picture/pic35.png`},
    {img: `picture/pic36.png`},
    {img: `picture/pic37.png`},
    {img: `picture/pic38.png`},
    {img: `picture/pic39.png`},
    {img: `picture/pic40.png`},
    {img: `picture/pic41.png`},
    {img: `picture/pic42.png`},
    {img: `picture/pic43.png`},
    {img: `picture/pic44.png`},
    {img: `picture/pic45.png`},
    {img: `picture/pic46.png`},
    {img: `picture/pic47.png`},
    {img: `picture/pic48.png`},
    {img: `picture/pic49.png`},
    {img: `picture/pic50.png`},
    {img: `picture/pic51.png`},
    {img: `picture/pic52.png`},
    {img: `picture/pic53.png`},
    {img: `picture/pic54.png`},
    {img: `picture/pic55.png`},
    {img: `picture/pic56.png`},
    {img: `picture/pic57.png`},
    {img: `picture/pic58.png`},
    {img: `picture/pic59.png`},
    {img: `picture/pic60.png`},
    {img: `picture/pic61.png`},
    {img: `picture/pic62.png`},
    {img: `picture/pic63.png`},
    {img: `picture/pic64.png`},
    {img: `picture/pic65.png`},
    {img: `picture/pic66.png`},
    {img: `picture/pic67.png`},
    {img: `picture/pic68.png`},
    {img: `picture/pic69.png`},
    {img: `picture/pic70.png`},
    {img: `picture/pic71.png`},
    {img: `picture/pic72.png`},
    {img: `picture/pic73.png`},
    {img: `picture/pic74.png`},
    {img: `picture/pic75.png`},
    {img: `picture/pic76.png`},
];

// 装饰线
export const   decorativeList = [
    {img: `decorative/decorative1.png`},
    {img: `decorative/decorative2.png`},
    {img: `decorative/decorative3.png`},
    {img: `decorative/decorative4.png`},
    {img: `decorative/decorative5.png`},
    {img: `decorative/decorative6.png`},
    {img: `decorative/decorative7.png`},
    {img: `decorative/decorative8.png`},
    {img: `decorative/decorative9.png`},
    {img: `decorative/decorative10.png`},
    {img: `decorative/decorative12.png`},
    {img: `decorative/decorative13.png`},
    {img: `decorative/decorative14.png`},
    {img: `decorative/decorative15.png`},
    {img: `decorative/decorative16.png`},
    {img: `decorative/decorative17.png`},
    {img: `decorative/decorative18.png`},
    {img: `decorative/decorative19.png`},
    {img: `decorative/decorative20.png`},
    {img: `decorative/decorative21.png`},
    {img: `decorative/decorative22.png`},
    {img: `decorative/decorative23.png`},
    {img: `decorative/decorative24.png`},
    {img: `decorative/decorative25.png`},
    {img: `decorative/decorative26.png`},
    {img: `decorative/decorative27.png`},
    {img: `decorative/decorative28.png`},
    {img: `decorative/decorative29.png`},
    {img: `decorative/decorative30.png`},
    {img: `decorative/decorative31.png`},
    {img: `decorative/decorative32.png`},
    {img: `decorative/decorative33.png`},
    {img: `decorative/decorative34.png`},
    {img: `decorative/decorative35.png`},
    {img: `decorative/decorative36.png`},
    {img: `decorative/decorative37.png`},
    {img: `decorative/decorative38.png`},
    {img: `decorative/decorative39.png`},
    {img: `decorative/decorative40.png`},
    {img: `decorative/decorative41.png`},
    {img: `decorative/decorative42.png`},
    {img: `decorative/decorative43.png`},
    {img: `decorative/decorative44.png`},
    {img: `decorative/decorative45.png`},
    {img: `decorative/decorative46.png`},
    {img: `decorative/decorative47.png`},
    {img: `decorative/decorative48.png`},
    {img: `decorative/decorative49.png`},
    {img: `decorative/decorative50.png`},
    {img: `decorative/decorative51.png`},
    {img: `decorative/decorative52.png`},
    {img: `decorative/decorative53.png`},
    {img: `decorative/decorative54.png`},
    {img: `decorative/decorative55.png`},
    {img: `decorative/dec1.png`},
    {img: `decorative/dec2.png`},
    {img: `decorative/decorative56.png`},
    {img: `decorative/decorative57.png`},
    {img: `decorative/decorative58.png`},
    {img: `decorative/decorative59.png`},
    {img: `decorative/decorative60.png`},
    {img: `decorative/decorative61.png`},
    {img: `decorative/decorative62.png`},
    {img: `decorative/decorative63.png`},
    {img: `decorative/decorative64.png`},
    {img: `decorative/decorative65.png`},
    {img: `decorative/decorative66.png`},
    {img: `decorative/decorative67.png`},
    {img: `decorative/decorative68.png`},
    {img: `decorative/decorative69.png`},
    {img: `decorative/decorative70.png`},
];

//按钮背景
export const   btnList = [
    {img: `/btn/btn1.png`},
    {img: `/btn/btn2.png`},
    {img: `/btn/btn3.png`},
    {img: `/btn/btn4.png`},
    {img: `/btn/btn5.png`},
    {img: `/btn/btn6.png`},
    {img: `/btn/btn7.png`},
    {img: `/btn/btn8.png`},
    {img: `/btn/btn9.png`},
    {img: `/btn/btn10.png`},
    {img: `/btn/btn11.png`},
    {img: `/btn/btn12.png`},
    {img: `/btn/btn13.png`},
    {img: `/btn/btn14.png`},
    {img: `/btn/btn15.png`},
    {img: `/btn/btn16.png`},
    {img: `/btn/btn17.png`},
    {img: `/btn/btn18.png`},
    {img: `/btn/btn19.png`},
    {img: `/btn/btn20.png`},
    {img: `/btn/btn21.png`},
    {img: `/btn/btn22.png`},
    {img: `/btn/btn23.png`},
    {img: `/btn/btn24.png`},
    {img: `/btn/btn25.png`},
    {img: `/btn/btn26.png`},
    {img: `/btn/btn27.png`},
    {img: `/btn/btn28.png`},
    {img: `/btn/btn29.png`},
    {img: `/btn/btn30.png`},
    {img: `/btn/btn31.png`},
    {img: `/btn/btn32.png`},
    {img: `/btn/btn33.png`},
    {img: `/btn/btn34.png`},
    {img: `/btn/btn35.png`},
];
